import { login } from "@/api/login";
import { auth } from "common";
import Qs from "qs";
const platLogin = {
  state: {},
  mutations: {},
  actions: {
    Login({ commit }, data) {
      return new Promise((resolve, reject) => {
        if (auth.getToken()) {
          auth.removeToken();
        }
        login(Qs.stringify(data))
          .then((res) => {
            if (res.code === "00000") {
              let data = res.data;
              if (data) {
                let userInfo = {
                  id: res.data.userId,
                  userUuid: res.data.userUuid,
                  username: res.data.username,
                  account: res.data.account,
                };
                auth.setUserInfo(userInfo);
                auth.saveToken(res.data.access_token);
                //储存登录时间点，过期时间等
                let loginInfo = {
                  refresh_token: res.data.refresh_token,
                  expiresTime: res.data.expires_in,
                  loginTime: new Date().getTime(),
                };
                auth.saveLoginInfo(loginInfo);
              }
              resolve(data);
            } else {
              reject();
            }
          })
          .catch(() => {
            reject();
          });
      });
    },
  },
};
export default platLogin;
